export enum PostVisibility {
  draft = 'draft',
  published = 'published',
  locked = 'locked',
  drip = 'drip',
}

export enum PostContentType {
  quiz = 'quiz',
  assignment = 'assignment',
  video = 'video',
  audio = 'audio',
  embed = 'embed',
  text = 'text',
  funnel = 'funnel',
}

export interface PostMaterial {
  id: string
  createdAt?: string
  deletedAt?: string | null
  locationId?: string
  originId?: string | null
  postId?: string
  sequenceNo?: number
  title?: string
  type?: string
  updatedAt?: string
  url?: string
  userId?: string
}

export interface EmbeddedMediaJSON {
  src: string
  height: string
  width: string
  allowFullScreen: boolean
}

export interface EmbeddedMediaRes {
  meta: EmbeddedMediaJSON
  source: string
  contentType: string
  entityId: string
  entityType: string
  locationId: string
  createdAt: string
  updatedAt: string
}

export interface Post {
  id: string
  title: string
  description?: string
  visibility?: PostVisibility
  categoryId?: string
  productId?: string
  posterImage?: string
  commentStatus?: PostCommentStatus
  contentId?: string
  contentType: PostContentType
  sequenceNo?: number
  commentPermission?: string
  video?: {
    title?: string
    url?: string
    postId?: string
    thumbnail?: string
    transcodingStatus?: string
    hdTranscoded?: boolean
    videoFormats?: Array<string>
    transcoderWorkerVideoId?: string
    assetsLicenseId?: string
    metaData?: {
      subtitles?: Record<string, string>
    }
  }
  audio?: {
    url?: string
    assetsLicenseId?: string
    postId?: string
    id?: string
  }
  post_materials?: PostMaterial[]
  type?: string
  dripDays?: number
  asset_urls?: {
    licenseId?: string
    url?: string
    processedUrl?: string
    assetType?: string
    status?: string
    createdAt?: string
    updatedAt?: string
  } | null

  lockedByPost?: string | null
  lockedByCategory?: string | null
  certificateTemplateId?: string | null
  metaData?: {
    embedMediaId?: string
    [key: string]: any
  } | null

  embedJson?: EmbeddedMediaJSON | null
  embedded_media?: EmbeddedMediaRes
  funnelPage?: {
    id?: string
    funnelId?: string
    funnelPageId?: string
    funnelName?: string
    pageName?: string
    domainPresent?: boolean
    domainName?: string
  }
}

// For the constructor payload
export interface PostPayload {
  title?: string
  description?: string
  visibility?: string
  categoryId?: string
  productId?: string
  posterImage?: string
  commentStatus?: string
  contentId?: string
  contentType?: string
  sequenceNo?: number
  post_materials?: Array<any>
  asset_urls?: object
  video?: any
  commentPermission?: string
  lockedByPost?: string
  audio?: any
  certificateTemplateId?: string
  metaData?: {
    embedMediaId?: string
    [key: string]: any
  }
  embedJson?: {
    url: string
    height: string
    width: string
    allowFullScreen: boolean
  }
}

export enum PostCommentStatus {
  visible = 'visible',
  hidden = 'hidden',
  locked = 'locked',
  enabled = 'enabled',
}

export enum PostContentTypeLabel {
  quiz = 'Quiz',
  assignment = 'Assignment',
}

export enum EMBED_SOURCE {
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
  LOOM = 'loom',
  WISTIA = 'wistia',
  SOUNDCLOUD = 'soundcloud',
  SPOTIFY = 'spotify',
  MIXCLOUD = 'mixcloud',
}

export enum EMBED_CONTENT_TYPE {
  AUDIO = 'audio',
  VIDEO = 'video',
}
